import { AppHelmet } from '@pendwa/common-browser/components/AppHelmet/index.js';
import { LayoutContainer } from '@pendwa/common-browser/components/LayoutContainer/index.js';
import { LayoutContainerNarrow } from '@pendwa/common-browser/components/LayoutContainerNarrow/index.js';
import { LayoutPageSection } from '@pendwa/common-browser/components/LayoutPageSection/index.js';
import { LayoutSpacer } from '@pendwa/common-browser/components/LayoutSpacer/index.js';
import { Footer } from '@pendwa/common-browser/components/Navs/Footer/index.js';
import { Nav } from '@pendwa/common-browser/components/Navs/Nav/index.js';
import { redirectToPath } from '@pendwa/common-browser/core/appLocation/index.js';
import { appStoreCredentials } from '@pendwa/common-browser/core/appStore/credentials.js';
import { getAbsoluteUrlToSite } from '@pendwa/common-browser/utils/getAbsoluteUrlToSite.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import React from 'react';
import { Link } from 'react-router-dom';
import { getFooterConfig } from '../../../../../../core/footer/config/index.js';
import { getNavConfig } from '../../../../../../core/nav/config/index.js';
import {
  getSignInNextPath,
  recordSignInNextPathFromURL,
} from '../../../../../../core/signInHelpers/index.js';
import { CreateOptions } from './Options.js';

export const Screen = () => {
  React.useEffect(() => {
    recordSignInNextPathFromURL();
  }, []);

  const { next } = getSignInNextPath();

  const handleSuccess = (params: { uuid: string; token: string }) => {
    /**
     * NOTE!!! Do not reset appStore here (appStore.clearAll();) as functions like merging crossword player values
     * when a user logs in will fail. We only reset appStore when a user logs out
     */
    appStoreCredentials.set('uuid', params.uuid);
    appStoreCredentials.set('token', params.token);

    // we cannot just push the new location since apollo does
    // not update the token, so we do a full reload redirect
    redirectToPath(
      next ||
        (domain_env_pendwa_app
          ? rootRoutes.shows.main.get()
          : domain_env_africacrosswords_com
            ? rootRoutes.crosswords.main.get()
            : domain_env_swiftcomment_com
              ? rootRoutes.sc.main.get()
              : domain_env_pendwa_org
                ? rootRoutes.console.main.get()
                : ''),
      false
    );
  };

  return (
    <>
      <AppHelmet
        title={`Sign In | ${browserRootConfig.project.name}`}
        description={`Sign in to your account on ${browserRootConfig.project.name}.`}
        canonical_url={getAbsoluteUrlToSite(rootRoutes.app.account.login.get())}
      />

      <Nav getConfig={getNavConfig} />

      <LayoutPageSection className="flex justify-center bg-gray-50">
        <LayoutContainerNarrow>
          <LayoutSpacer>
            <img
              className="mx-auto h-24 w-auto"
              src={`https://res.cloudinary.com/pendwa/image/upload/w_512,h_512/public/assets/${DOMAIN_ENV}/logo/transparent-2560×2560.png`}
              alt={`${browserRootConfig.project.name} logo`}
            />

            <h1 className="text-center text-3xl font-extrabold text-gray-900">Sign in to your account</h1>

            <CreateOptions handleSuccess={handleSuccess} />

            <div className="flex flex-col items-center justify-center">
              <p className="text-center text-sm text-gray-600">Don&apos;t have an account yet</p>
              <div className="text-sm">
                <Link
                  to={rootRoutes.app.account.create.get(next)}
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Create Your Account
                </Link>
              </div>
            </div>
          </LayoutSpacer>
        </LayoutContainerNarrow>
      </LayoutPageSection>

      <LayoutPageSection>
        <LayoutContainer>
          <Footer getConfig={getFooterConfig} />
        </LayoutContainer>
      </LayoutPageSection>
    </>
  );
};
